<div class="clr-row nxm h-100 padding-12-b">
  <div class="clr-col-{{ inforClosed() ? 12 : 6 }} h-100">
    @if (kostenTable.columns()?.length) {
      <clr-datagrid #datagrid class="auftragDetailKostenTable h-100">
        @for (column of kostenTable.columns(); track column.id) {
          <clr-dg-column>
            <ng-container
              *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['kostentyp', 'kostenid', 'export', 'task'] }">
              {{ column.id | titlecase | mrTranslate }}
            </ng-container>
          </clr-dg-column>
        }

        <!-- PERSONAL ROWS -->
        @if (kostenTable.rows.personal().length; as length) {
          <clr-dg-row>
            <clr-dg-cell class="headlineRow">
              {{ 'Personal' | mrTranslate | uppercase }}
              <span class="badge badge-success" style="margin-left: 0.3em">{{ length }}</span>
            </clr-dg-cell>
          </clr-dg-row>
          @for (row of kostenTable.rows.personal(); track row.ID) {
            <clr-dg-row>
              @if (isPlankosten()) {
                <clr-dg-action-overflow>
                  <button class="action-item" (click)="deleteItem('personal', row)">
                    {{ 'Personal löschen' | mrTranslate }}
                  </button>
                </clr-dg-action-overflow>
              }
              @for (cell of kostenTable.columns(); track cell.id) {
                <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
              }
            </clr-dg-row>
          }
        }

        <!-- MATERIAL ROWS -->
        @if (kostenTable.rows.material().length; as length) {
          <clr-dg-row>
            <clr-dg-cell class="headlineRow">
              {{ 'Material' | mrTranslate | uppercase }}
              <span class="badge badge-success" style="margin-left: 0.3em">{{ length }}</span>
            </clr-dg-cell>
          </clr-dg-row>
          @for (row of kostenTable.rows.material(); track row.ID) {
            <clr-dg-row>
              @if (isPlankosten()) {
                <clr-dg-action-overflow>
                  <button class="action-item" (click)="deleteItem('material', row)">
                    {{ 'Material löschen' | mrTranslate }}
                  </button>
                </clr-dg-action-overflow>
              }
              @for (cell of kostenTable.columns(); track cell.id) {
                <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
              }
            </clr-dg-row>
          }
        }

        <!-- MASCHINE ROWS -->
        @if (kostenTable.rows.maschine().length; as length) {
          <clr-dg-row>
            <clr-dg-cell class="headlineRow">
              {{ 'Maschinen' | mrTranslate | uppercase }}
              <span class="badge badge-success" style="margin-left: 0.3em">{{ length }}</span>
            </clr-dg-cell>
          </clr-dg-row>
          @for (row of kostenTable.rows.maschine(); track row.ID) {
            <clr-dg-row>
              @if (isPlankosten()) {
                <clr-dg-action-overflow>
                  <button class="action-item" (click)="deleteItem('maschine', row)">
                    {{ 'Maschine löschen' | mrTranslate }}
                  </button>
                </clr-dg-action-overflow>
              }
              @for (cell of kostenTable.columns(); track cell.id) {
                <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
              }
            </clr-dg-row>
          }
        }

        <!-- FREMDLEISTUNG ROWS -->
        @if (kostenTable.rows.fremdleistung().length; as length) {
          <clr-dg-row>
            <clr-dg-cell class="headlineRow">
              {{ 'Fremdleistungen' | mrTranslate | uppercase }}
              <span class="badge badge-success" style="margin-left: 0.3em">{{ length }}</span>
            </clr-dg-cell>
          </clr-dg-row>
          @for (row of kostenTable.rows.fremdleistung(); track row.ID) {
            <clr-dg-row>
              @if (isPlankosten()) {
                <clr-dg-action-overflow>
                  <button class="action-item" (click)="deleteItem('fremdleistung', row)">
                    {{ 'Fremdleistung löschen' | mrTranslate }}
                  </button>
                </clr-dg-action-overflow>
              }
              @for (cell of kostenTable.columns(); track cell.id) {
                <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
              }
            </clr-dg-row>
          }
        }

        <clr-dg-footer>
          <div>{{ rowsCount() }} {{ 'Zeilen' | mrTranslate }}</div>
          <div style="display: flex; justify-content: space-evenly">
            <strong>{{ 'Kosten' | mrTranslate }}: {{ kostenTable.summary.kosten() }}&nbsp;€</strong>
            <strong>{{ 'Plankosten' | mrTranslate }}: {{ kostenTable.summary.plankosten() }}&nbsp;€</strong>
          </div>
        </clr-dg-footer>
      </clr-datagrid>
    }
  </div>
  @if (!inforClosed()) {
    <div class="clr-col-6 h-100">
      <clr-tabs>
        <clr-tab>
          <button clrTabLink>
            {{ 'Personal' | mrTranslate }}
          </button>
          <clr-tab-content *clrIfActive>
            <app-kosten-edit-modal
              mode="personal"
              [data]="modalData.personal"
              [open]="modals.personal"
              [mengeneinheiten]="meh()"
              (close)="closeModal('personal', $event)"></app-kosten-edit-modal>

            <!-- Personal Kosten Form -->
            <div class="clr-row">
              <div class="clr-col" style="min-width: 70%">
                <form clrForm [formGroup]="personalForm" [clrLabelSize]="4" class="width100">
                  <clr-date-container style="margin-top: 0.6em">
                    <label class="clr-required-mark">{{ 'Datum' | mrTranslate }}</label>
                    <input
                      type="date"
                      clrDate
                      name="datum"
                      autocomplete="off"
                      [ngModel]="personalForm.get('datum').value | localeDate"
                      (ngModelChange)="personalForm.get('datum').setValue(localeDate.tosql($event))"
                      [ngModelOptions]="{ standalone: true, updateOn: 'blur' }"
                      [disabled]="personalForm.disabled"
                      required />
                  </clr-date-container>
                  @if (isPlankosten()) {
                    <clr-number-input-container class="inputLine">
                      <label class="clr-required-mark">{{ 'Arbeitszeit' | mrTranslate }}</label>
                      <input clrNumberInput type="number" formControlName="arbeitszeit" min="1" max="24" />
                    </clr-number-input-container>
                  } @else {
                    <clr-input-container class="inputLine">
                      <label class="clr-required-mark">{{ 'Arbeitszeit Start' | mrTranslate }}</label>
                      <input clrInput type="time" formControlName="arbeitszeitStart" />
                    </clr-input-container>
                    <clr-input-container class="inputLine">
                      <label class="clr-required-mark">{{ 'Arbeitszeit Ende' | mrTranslate }}</label>
                      <input clrInput type="time" formControlName="arbeitszeitEnde" />
                    </clr-input-container>
                  }
                  <!-- <label>{{(zeiten.personal || 0) + ' h'}}</label> -->
                  <div class="comboboxcontainer clr-form-control clr-row">
                    <label class="clr-col-md-4 clr-control-label clr-required-mark">
                      {{ 'Tätigkeit' | mrTranslate }}
                    </label>
                    <div class="clr-control-container clr-col-md-8">
                      <input
                        class="clr-input combobox"
                        placeholder=""
                        type="search"
                        name="taetigkeit"
                        formControlName="taetigkeit"
                        list="tpList" />
                    </div>
                    <datalist id="tpList">
                      @if (taetigkeiten.personal) {
                        @for (name of taetigkeiten.personal; track name) {
                          <option
                            [value]="name === noActivitiesSentinel ? ('--Keine Tätigkeiten--' | mrTranslate) : name"></option>
                        }
                      }
                    </datalist>
                  </div>
                  <clr-textarea-container>
                    <label>{{ 'Bemerkung' | mrTranslate }}</label>
                    <textarea clrTextarea formControlName="bemerkung" name="bemerkung"></textarea>
                  </clr-textarea-container>
                </form>
              </div>
              <div
                class="clr-col"
                style="display: flex; justify-content: flex-end; align-items: flex-end; max-width: 30%">
                <button
                  type="button"
                  class="btn btn-primary"
                  style="margin-right: 0px"
                  (click)="saveKosten('personal')"
                  [disabled]="trial || (auftrag()?.Auftragsstatus != 0 && !isPlankosten())">
                  {{ ('Kosten' | mrTranslate) + ' ' + ('speichern' | mrTranslate) }}
                </button>
              </div>
            </div>
            <div class="clr-row">
              <div class="clr-col">
                <clr-button-group class="btn-primary btn-sm" style="margin-top: 0.5em">
                  @if (isHxGN_Interface) {
                    <clr-button (click)="importHxGNEAM('personal')">
                      {{ 'Import' | mrTranslate }}
                    </clr-button>
                  } @else {
                    <clr-button (click)="openModal('personal', null)" [disabled]="!selected">
                      {{ 'Hinzufügen' | mrTranslate }}
                    </clr-button>
                    <clr-button
                      (click)="deleteFremdleistung(selected.personal, 'personal')"
                      [disabled]="trial || !selected.personal">
                      {{ 'Löschen' | mrTranslate }}
                    </clr-button>
                  }
                </clr-button-group>
              </div>
            </div>

            <!-- Personal Datagrid -->
            @if (personalTable.rows) {
              <clr-datagrid
                #datagrid
                class="datagrid-compact"
                style="height: calc(100% - 320px)"
                [clrDgSelectionType]="'multi'"
                [(clrDgSelected)]="selectedpersonal"
                [clrDgItemsIdentityFn]="row => row?.ID">
                @for (column of personalTable.columns; track column) {
                  <clr-dg-column [clrDgField]="column.id">
                    <ng-container
                      *clrDgHideableColumn="{
                        hidden: column.id | hideIDColumns: ['kauftmid', 'bezirk', 'stellwerk', 'bild'],
                      }">
                      {{ column.id | titlecase | mrTranslate }}
                    </ng-container>
                  </clr-dg-column>
                }
                <ng-template
                  clrVirtualScroll
                  let-row
                  [clrVirtualRowsOf]="personalTable.rows"
                  [clrVirtualRowsTrackBy]="(_, row) => row?.ID">
                  <clr-dg-row [clrDgItem]="row">
                    <clr-dg-action-overflow>
                      <button class="action-item" (click)="openModal('personal', row)">
                        {{ 'Personal bearbeiten' | mrTranslate }}
                      </button>
                    </clr-dg-action-overflow>
                    @for (cell of personalTable.columns; track cell) {
                      <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                    }
                  </clr-dg-row>
                </ng-template>
                <clr-dg-footer>{{ personalTable.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
              </clr-datagrid>
            }
          </clr-tab-content>
        </clr-tab>
        @if (!isHxGN_Interface || !multiObj()) {
          <clr-tab>
            <button clrTabLink>
              {{ 'Material' | mrTranslate }}
              @if (isMaterialLoading()) {
                <clr-spinner clrMedium clrInverse />
              }
            </button>
            <clr-tab-content *clrIfActive>
              <app-kosten-edit-modal
                mode="material"
                [data]="modalData.material"
                [open]="modals.material"
                [mengeneinheiten]="meh()"
                (close)="closeModal('material', $event)"
                [data]="modalData.material"></app-kosten-edit-modal>

              <!-- Material Kosten Form -->

              <div class="clr-row">
                <div class="clr-col" style="min-width: 50%">
                  <form clrForm [formGroup]="materialForm" [clrLabelSize]="4" class="width100">
                    <clr-date-container style="margin-top: 0.6em">
                      <label class="clr-required-mark">{{ 'Datum' | mrTranslate }}</label>
                      <input
                        type="date"
                        clrDate
                        name="datum"
                        [ngModel]="materialForm.get('datum').value | localeDate"
                        (ngModelChange)="materialForm.get('datum').setValue(localeDate.tosql($event))"
                        [ngModelOptions]="{ standalone: true, updateOn: 'blur' }"
                        [disabled]="materialForm.disabled"
                        required />
                    </clr-date-container>
                    <clr-number-input-container>
                      <label class="clr-required-mark">{{ 'Anzahl' | mrTranslate }}</label>
                      <input clrNumberInput type="number" formControlName="anzahl" />
                    </clr-number-input-container>
                    <clr-textarea-container>
                      <label>{{ 'Bemerkung' | mrTranslate }}</label>
                      <textarea clrTextarea formControlName="bemerkung" name="bemerkung"></textarea>
                    </clr-textarea-container>
                  </form>
                </div>
                <div
                  class="clr-col"
                  style="display: flex; justify-content: flex-end; align-items: flex-end; max-width: 30%">
                  <button
                    type="button"
                    class="btn btn-primary"
                    style="margin-right: 0px"
                    (click)="saveKosten('material')"
                    [disabled]="trial || (auftrag()?.Auftragsstatus != 0 && !isPlankosten())">
                    {{ ('Kosten' | mrTranslate) + ' ' + ('speichern' | mrTranslate) }}
                  </button>
                </div>
              </div>
              <div class="clr-row">
                <div class="clr-col">
                  <clr-button-group class="btn-primary btn-sm" style="margin-top: 0.5em">
                    @if (isHxGN_Interface) {
                      <clr-button (click)="importHxGNEAM('material')">
                        {{ 'Import' | mrTranslate }}
                      </clr-button>
                    } @else {
                      <clr-button (click)="openModal('material', null)" [disabled]="!selected">
                        {{ 'Hinzufügen' | mrTranslate }}
                      </clr-button>
                      <clr-button
                        (click)="deleteFremdleistung(selected.material, 'material')"
                        [disabled]="trial || !selected.material">
                        {{ 'Löschen' | mrTranslate }}
                      </clr-button>
                    }
                  </clr-button-group>
                </div>
              </div>

              <!-- Material Datagrid -->

              @if (materialTable.rows !== null) {
                <clr-datagrid
                  #datagrid
                  [clrDgSelectionType]="'single'"
                  [clrDgSelected]="[selected.material]"
                  (clrDgSelectedChange)="selected.material = $event[0]"
                  class="datagrid-compact auftragDetailMaterialTable"
                  id="materialTable"
                  style="height: calc(100% - 220px)"
                  [clrDgItemsIdentityFn]="row => row?.ID">
                  @for (column of materialTable.columns; track column) {
                    <clr-dg-column [clrDgField]="column.id">
                      <ng-container
                        *clrDgHideableColumn="{
                          hidden: column.id | hideIDColumns: ['kauftmid', 'bezirk', 'stellwerk', 'bild'],
                        }">
                        {{ column.id | titlecase | mrTranslate }}
                      </ng-container>
                    </clr-dg-column>
                  }
                  <ng-template
                    clrVirtualScroll
                    let-row
                    [clrVirtualRowsOf]="materialTable.rows"
                    [clrVirtualRowsTrackBy]="(_, row) => row?.ID">
                    <clr-dg-row [clrDgItem]="row">
                      <clr-dg-action-overflow>
                        <button class="action-item" (click)="openModal('material', row)">
                          {{ 'Material bearbeiten' | mrTranslate }}
                        </button>
                      </clr-dg-action-overflow>
                      @for (cell of materialTable.columns; track cell) {
                        <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                      }
                    </clr-dg-row>
                  </ng-template>
                  <clr-dg-footer>{{ materialTable.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                </clr-datagrid>
              }
            </clr-tab-content>
          </clr-tab>
        }
        <clr-tab>
          <button clrTabLink>
            {{ 'Maschinen' | mrTranslate }}
          </button>
          <clr-tab-content *clrIfActive>
            <app-kosten-edit-modal
              mode="maschine"
              [data]="modalData.maschine"
              [open]="modals.maschine"
              (close)="closeModal('maschine', $event)"
              [data]="modalData.maschine"></app-kosten-edit-modal>

            <!-- Maschinen Kosten Form -->
            <div class="clr-row">
              <div class="clr-col" style="min-width: 50%">
                <form clrForm [formGroup]="maschinenForm" [clrLabelSize]="4" class="width100">
                  <clr-date-container style="margin-top: 0.6em">
                    <label class="clr-required-mark">{{ 'Datum' | mrTranslate }}</label>
                    <input
                      type="date"
                      clrDate
                      name="datum"
                      [ngModel]="maschinenForm.get('datum').value | localeDate"
                      (ngModelChange)="maschinenForm.get('datum').setValue(localeDate.tosql($event))"
                      [ngModelOptions]="{ standalone: true, updateOn: 'blur' }"
                      [disabled]="maschinenForm.disabled"
                      required />
                  </clr-date-container>
                  @if (isPlankosten()) {
                    <clr-number-input-container class="inputLine">
                      <label class="clr-required-mark">{{ 'Arbeitszeit' | mrTranslate }}</label>
                      <input clrNumberInput type="number" formControlName="arbeitszeit" min="1" max="24" />
                    </clr-number-input-container>
                  } @else {
                    <clr-input-container class="inputLine">
                      <label class="clr-required-mark">{{ 'Arbeitszeit Start' | mrTranslate }}</label>
                      <input clrInput type="time" formControlName="arbeitszeitStart" />
                    </clr-input-container>
                    <clr-input-container class="inputLine">
                      <label class="clr-required-mark">{{ 'Arbeitszeit Ende' | mrTranslate }}</label>
                      <input clrInput type="time" formControlName="arbeitszeitEnde" />
                    </clr-input-container>
                  }
                  <div class="comboboxcontainer clr-form-control clr-row">
                    <label class="clr-col-md-4 clr-control-label clr-required-mark">
                      {{ 'Tätigkeit' | mrTranslate }}
                    </label>
                    <div class="clr-control-container clr-col-md-8">
                      <input
                        class="clr-input combobox"
                        placeholder=""
                        type="search"
                        name="taetigkeit"
                        formControlName="taetigkeit"
                        list="tmList" />
                    </div>
                    <datalist id="tmList">
                      @if (taetigkeiten.maschine) {
                        @for (name of taetigkeiten.maschine; track name) {
                          <option
                            [value]="name === noActivitiesSentinel ? ('--Keine Tätigkeiten--' | mrTranslate) : name"></option>
                        }
                      }
                    </datalist>
                  </div>
                  <clr-textarea-container>
                    <label>{{ 'Bemerkung' | mrTranslate }}</label>
                    <textarea clrTextarea formControlName="bemerkung" name="bemerkung"></textarea>
                  </clr-textarea-container>
                </form>
              </div>
              <div
                class="clr-col"
                style="display: flex; justify-content: flex-end; align-items: flex-end; max-width: 30%">
                <button
                  type="button"
                  class="btn btn-primary"
                  style="margin-right: 0px"
                  (click)="saveKosten('maschine')"
                  [disabled]="trial || (auftrag()?.Auftragsstatus != 0 && !isPlankosten())">
                  {{ ('Kosten' | mrTranslate) + ' ' + ('speichern' | mrTranslate) }}
                </button>
              </div>
            </div>
            <div class="clr-row">
              <div class="clr-col">
                <clr-button-group class="btn-primary btn-sm" style="margin-top: 0.5em">
                  @if (isHxGN_Interface) {
                    <clr-button (click)="importHxGNEAM('maschine')">
                      {{ 'Import' | mrTranslate }}
                    </clr-button>
                  } @else {
                    <clr-button (click)="openModal('maschine', null)" [disabled]="!selected">
                      {{ 'Hinzufügen' | mrTranslate }}
                    </clr-button>
                    <clr-button
                      (click)="deleteFremdleistung(selected.maschine, 'maschine')"
                      [disabled]="trial || !selected.maschine">
                      {{ 'Löschen' | mrTranslate }}
                    </clr-button>
                  }
                </clr-button-group>
              </div>
            </div>

            <!-- Maschinen Datagrid -->

            @if (maschinenTable.rows !== null) {
              <clr-datagrid
                #datagrid
                [clrDgSelectionType]="'single'"
                [clrDgSelected]="[selected.maschine]"
                (clrDgSelectedChange)="selected.maschine = $event[0]"
                class="datagrid-compact auftragDetailMaschinenTable"
                id="maschinenTable"
                style="height: calc(100% - 320px)"
                [clrDgItemsIdentityFn]="row => row?.ID">
                @for (column of maschinenTable.columns; track column) {
                  <clr-dg-column [clrDgField]="column.id">
                    <ng-container
                      *clrDgHideableColumn="{
                        hidden: column.id | hideIDColumns: ['kauftmid', 'bezirk', 'stellwerk', 'bild'],
                      }">
                      {{ column.id | titlecase | mrTranslate }}
                    </ng-container>
                  </clr-dg-column>
                }
                <ng-template
                  clrVirtualScroll
                  let-row
                  [clrVirtualRowsOf]="maschinenTable.rows"
                  [clrVirtualRowsTrackBy]="(_, row) => row?.ID">
                  <clr-dg-row [clrDgItem]="row">
                    <clr-dg-action-overflow>
                      <button class="action-item" (click)="openModal('maschine', row)">
                        {{ 'Maschine bearbeiten' | mrTranslate }}
                      </button>
                    </clr-dg-action-overflow>
                    @for (cell of maschinenTable.columns; track cell) {
                      <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                    }
                  </clr-dg-row>
                </ng-template>
                <clr-dg-footer>{{ maschinenTable.rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
              </clr-datagrid>
            }
          </clr-tab-content>
        </clr-tab>
        @if (!isHxGN_Interface || !multiObj()) {
          <clr-tab>
            <button clrTabLink>
              {{ 'Fremdleistungen' | mrTranslate }}
            </button>
            <clr-tab-content *clrIfActive>
              <app-kosten-fremdleistung-modal
                [fremdleistung]="selected.fremdleistung"
                [open]="modals.fremdleistung"
                [mengeneinheiten]="meh()"
                (close)="closeModal('fremdleistung', $event)"></app-kosten-fremdleistung-modal>

              <div class="clr-row">
                <div class="clr-col" style="min-width: 69%">
                  <form
                    clrForm
                    [formGroup]="fremdleistungForm"
                    id="fremdleistungForm"
                    [clrLabelSize]="4"
                    class="width100">
                    <clr-date-container style="margin-top: 0.6em">
                      <label class="clr-required-mark">{{ 'Datum' | mrTranslate }}</label>
                      <input
                        type="date"
                        clrDate
                        name="datum"
                        [ngModel]="fremdleistungForm.get('datum').value | localeDate"
                        (ngModelChange)="fremdleistungForm.get('datum').setValue(localeDate.tosql($event))"
                        [ngModelOptions]="{ standalone: true, updateOn: 'blur' }"
                        [disabled]="fremdleistungForm.disabled"
                        required />
                    </clr-date-container>
                    <clr-input-container id="kurztextInput">
                      <label>{{ 'Kurztext' | mrTranslate }}</label>
                      <input clrInput formControlName="kurztext" />
                    </clr-input-container>
                    <div id="anzahlEinheitInput" class="clr-row">
                      <div class="clr-col-8">
                        <clr-input-container id="anzahlInput">
                          <label class="clr-required-mark clr-col-12 clr-col-md-6">
                            {{ 'Anzahl / Einheit' | mrTranslate }}
                          </label>
                          <input
                            class="clr-col-12 clr-col-md-6 padding-10-l"
                            clrInput
                            [placeholder]="'Anzahl' | mrTranslate"
                            type="number"
                            formControlName="anzahl" />
                        </clr-input-container>
                      </div>
                      <div class="clr-col-4">
                        <div class="comboboxcontainer clr-form-control clr-row">
                          <div class="clr-control-container clr-col-md-8">
                            <input
                              class="clr-input combobox"
                              placeholder=""
                              type="search"
                              name="einheit"
                              formControlName="einheit"
                              list="ehList" />
                          </div>
                          <datalist id="ehList">
                            @for (val of meh(); track $index) {
                              <option [value]="val">{{ val }}</option>
                            }
                          </datalist>
                        </div>
                      </div>
                    </div>

                    <clr-textarea-container style="margin-top: 1.3em">
                      <label>{{ 'Bemerkung' | mrTranslate }}</label>
                      <textarea clrTextarea formControlName="bemerkung" name="bemerkung"></textarea>
                    </clr-textarea-container>
                  </form>
                </div>
                <div
                  class="clr-col"
                  style="/* display: flex; */ justify-content: flex-end; align-items: flex-end; max-width: 30%">
                  <div
                    class="clr-row"
                    style="height: 165px; justify-content: flex-end; align-items: flex-end; margin-right: 0px">
                    @if (isHxGN_Interface && !isPlankosten() && inforJobNrs().length) {
                      <button
                        type="button"
                        class="btn btn-primary"
                        style="margin-right: 0px"
                        (click)="saveFremdleistung()"
                        [disabled]="trial || auftrag()?.Auftragsstatus != 0">
                        {{ 'Fremdleistung planen' | mrTranslate }}
                      </button>
                    }
                  </div>
                  <div class="clr-row" style="justify-content: flex-end; align-items: flex-end; margin-right: 0px">
                    <button
                      type="button"
                      class="btn btn-primary"
                      style="margin-right: 0px"
                      (click)="saveKosten('fremdleistung')"
                      [disabled]="trial || auftrag()?.Auftragsstatus != 0">
                      {{ ('Kosten' | mrTranslate) + ' ' + ('speichern' | mrTranslate) }}
                    </button>
                  </div>
                </div>
              </div>
              @if (isHxGN_Interface) {
                <div class="clr-row">
                  <div class="clr-col">
                    <clr-button-group class="btn-primary btn-sm" style="margin-top: 0.5em">
                      <clr-button (click)="importHxGNEAM('fremdleistung')">{{ 'Import' | mrTranslate }}</clr-button>
                    </clr-button-group>
                  </div>
                </div>
              }
              @if (fremdleistungen?.length) {
                <div class="clr-row">
                  <div class="clr-col">
                    <app-fremdleistung-stack-view
                      [root]="fremdleistungen"
                      [deleteSelection]="$deleteSelection"
                      (selectionChange)="fremdleistungSelected($event)"
                      (action)="fremdleistungAction($event)" />
                  </div>
                </div>
              }
            </clr-tab-content>
          </clr-tab>
        }
      </clr-tabs>
    </div>
  }
</div>
